var map = {
	"./directives/templates/developerMetricsAvailable.html": 2175,
	"./directives/templates/friendRequest.html": 6511,
	"./directives/templates/gameUpdateActionPopoverTemplate.html": 1282,
	"./directives/templates/gameUpdateTemplate.html": 3851,
	"./directives/templates/groupMembership.html": 9585,
	"./directives/templates/newGameUpdateTemplate.html": 8537,
	"./directives/templates/notificationContentViewTemplate.html": 5951,
	"./directives/templates/notificationStreamBaseView.html": 3732,
	"./directives/templates/notificationStreamContainer.html": 3322,
	"./directives/templates/privateMessage.html": 8190,
	"./directives/templates/test.html": 3834
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6012;